import { SerpStoreClosureSnapshot } from '@/components/Approval/@components/SerpStoreClosure';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 181 SERP 폐점 정산 — 저장 content 그대로(레거시 조회와 동일) */
const SerpStoreClosureSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpStoreClosureSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpStoreClosureSlot;
